import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../../typings'

/**
 * Refreshes GPS Data
 *
 * @private
 */
export const editTenantSourceLabel = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  { tenantSourceId: string; label: string },
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/gps/telematics/editTenantSourceLabel', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/gps/telematics/editTenantSourceLabel', {
      category: 'rpc',
      payload,
      type: 'rpc/gps/telematics/editTenantSourceLabel',
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {editTenantSourceLabel}`,
      { tags: ['rpc'] },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Change of Telematics tenant source label failed`,
      error,
    })
  }
})
